import React from 'react';

const Products = () => {
  const products = [
    {
      pic: './assets/images/rhb.png',
      name: 'RHB',
      description: "RHB est fabriqué en Europe depuis 2017, et afin de répondre à la forte demande des malades algériens, TZ Lab et en partenariat avec BML VISION sarl ont décidé de relancer la production du RHB en Algérie début 2022 pour le marché local et l'export (capsules 100% naturelles composées d'huile d'olive et huiles essentielles). Aussi pour renforcer l'immunité et combattre la fatigue. (une ou deux capsules selon votre état). La fatigue disparait dès le premier jour. Pour gros et pharmacie même marge que médicament. Avec possibilité de la livraison 58 wilaya. Enregistrez votre commande et bénéficiez des ventes illimitée!",
    }
  ];
  return (
    <div className="w-full flex flex-col items-center pt-16">
      <h2 className="header">Nos Produits</h2>
      <div className="flex flex-wrap justify-center mt-10">
        {products.map((product) => (
          <div className="flex flex-col items-center w-1/4 min-w-[346px] mx-6 my-2 bg-white p-2 shadow-custom rounded-md">
            <img
              src={product.pic}
              alt="med"
              className="w-full h-60 object-cover object-top rounded-md"
            />
            <div className="font-inter px-2">
              <h3 className="text-xl font-bold text-primary-100 my-6">{product.name}</h3>
              <p>{product.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Products;
